import * as React from 'react';

import { Character } from '../../constants';
import { clickableProps } from '../../helpers/components';

export interface IHandlebarProps {
	isGrabbing?: boolean;
	onUpClick?: () => void;
	onDownClick?: () => void;
}

export const Handlebar: React.FC<IHandlebarProps> = ({ isGrabbing: isGrabbing, onUpClick, onDownClick }) => <div className="handlebar">
	<div className="handlebar__row handlebar__top">
		{onUpClick && !isGrabbing ?
			<div className="handlebar__cell handlebar__arrow" {...clickableProps(onUpClick)} aria-label="Move up">{Character.Up}</div> :
			<div className="handlebar__cell handlebar__arrow hidden grabbable">{Character.Up}</div>}
	</div>
	<div className="handlebar__row handlebar__middle">
		<div className={`handlebar__cell handlebar__grip grabbable`}>{Character.Grab}</div>
	</div>
	<div className="handlebar__row handlebar__bottom">
		{onDownClick && !isGrabbing ?
			<div className="handlebar__cell handlebar__arrow" {...clickableProps(onDownClick)} aria-label="Move down">{Character.Down}</div> :
			<div className="handlebar__cell handlebar__arrow hidden grabbable">{Character.Down}</div>}
	</div>
</div>;
